import { formatNumber, PayrollItemType, type PayrollReport } from "@pentacode/core";
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { shared } from "../../../../styles";

@customElement("ptc-payroll-report")
export class PayrollReportEl extends LitElement {
    @property({ attribute: false })
    report: PayrollReport;

    static styles = [
        shared,
        css`
            tr > :nth-child(2) {
                width: 3em;
            }

            tr > :nth-child(3) {
                width: 4em;
            }

            tr > :nth-child(4) {
                width: 5em;
            }

            tr > :nth-child(5) {
                width: 5em;
            }

            th.description {
                text-align: left;
            }

            td.number {
                text-align: right;
            }
        `,
    ];

    render() {
        if (!this.report) {
            return;
        }

        const items = this.report.items.filter((item) => !item.exportOnly);

        const displayAdjustedItems = items.map((item) => {
            if (item.type === PayrollItemType.HourAdjustment) {
                return {
                    ...item,
                    result: Math.abs(item.result || 0),
                    amount: Math.abs(item.amount || 0),
                };
            }
            return item;
        });

        const total = displayAdjustedItems.reduce((total, item) => total + (item.result || 0), 0);

        return html`
            <table class="simple">
                <thead>
                    <tr>
                        <th></th>
                        <th scope="col" class="number">Kst.</th>
                        <th scope="col" class="number">Menge</th>
                        <th scope="col" class="number">Einh.</th>
                        <th scope="col" class="number"><span class="nowrap">€ / Einh.</span></th>
                        <th scope="col" class="number"><span class="nowrap">Faktor (%)</span></th>
                        <th scope="col" class="number"><span class="nowrap">Betrag (€)</span></th>
                    </tr>
                </thead>
                <tbody>
                    ${displayAdjustedItems.map(
                        ({ description, icon, color, unit, amount, wagePerUnit, factor, result, type, costCenter }) => {
                            return html`
                                <tr>
                                    <td class="description" style="--color-highlight: ${color}">
                                        <ptc-ui-icon name="${icon || "icon.object.wage-item"}"></ptc-ui-icon>
                                        ${type === PayrollItemType.Commission ? html`Umsatzbeteiligung: ` : ""}
                                        ${description}
                                        ${type === PayrollItemType.BonusTaxed
                                            ? html`<sup class="smaller orange colored-text">*beitragspfl.</sup>`
                                            : ""}
                                    </td>
                                    <td class="number">${costCenter || html`<span class="subtle">N/A</span>`}</td>
                                    <td class="number">${formatNumber(amount)}</td>
                                    <td>${{ days: "T", hours: "Std.", euros: "€", pieces: "St." }[unit]}</td>
                                    <td class="number">${wagePerUnit ? formatNumber(wagePerUnit) : ""}</td>
                                    <td class="number">${factor ? formatNumber(factor) : ""}</td>
                                    <td class="number">${result ? formatNumber(result) : ""}</td>
                                </tr>
                            `;
                        }
                    )}
                    <tr class="bold">
                        <td><ptc-ui-icon name="icon.object.total"></ptc-ui-icon> Gesamt</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="number">${formatNumber(total)}</td>
                    </tr>
                </tbody>
            </table>
        `;
    }
}
